module.exports = __webpack_public_path__ + "static/media/welcome-yoga.a50f79d6.svg";